import { registerMessages } from "../../i18n/runtime";
import { portalNavEn } from "./messages.en";
import { portalNavEs } from "./messages.es";

// Imported by the module definition, not by the lazy screens: the sidebar needs these labels before any screen has loaded.
registerMessages("en", portalNavEn);
registerMessages("es", portalNavEs);
